import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id A1CCEE33-5CCA-43B9-B056-23F3EAFBE506
 * name tray-alert
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-alert.svg
 * tags
 * - Alert / Error 
 */
export const TrayAlertIcon = createSvgIcon(<><path d="M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17M13 12H11V14H13M13 4H11V10H13Z" /></>, 'TrayAlertIcon');
export default TrayAlertIcon